import React from 'react'

type Company = {
  rowId: string
  name: string
  legalName: string
}

type Organization = {
  rowId: string
  name: string
  legalName: string
  slug: string
  organizationSubscriptions?: any[]
}

export type ContextProps = {
  user: any
  setUser: (user: any) => void
  isLoggedIn: boolean
  isReady: boolean
  login(): Promise<void>
  logout(): void
  currentCompany: Company
  setCurrentCompany: (company: Company) => void
  currentOrg: Organization
  setCurrentOrg: (org: Organization) => void
  userIsCurrentOrgAdmin: boolean
  freeTrial: boolean
  trialDaysRemaining: number
}

const defaultCtx = {
  user: {},
  setUser: () => {},
  isLoggedIn: false,
  isReady: false,
  login: async () => {},
  logout: () => {},
  currentCompany: { rowId: '', name: '', legalName: '' },
  setCurrentCompany: () => {},
  currentOrg: { rowId: '', name: '', legalName: '', slug: '' },
  setCurrentOrg: () => {},
  userIsCurrentOrgAdmin: false,
  freeTrial: false,
  trialDaysRemaining: 0,
}

export default React.createContext<ContextProps>(defaultCtx)
